export default __webpack_public_path__ + "static/media/compliance.5dc28647.png";